export default __webpack_public_path__ + "static/media/780.c3a8e203.png";